// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Linkedin = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,0 12,0 C5.372583,0 0,5.372583 0,12 C0,18.627417 5.372583,24 12,24 Z M8.06097194,19.3333333 L5.1098611,19.3333333 L5.1098611,9.83111098 L8.06541665,9.83111098 L8.06541665,19.3333333 L8.06097194,19.3333333 Z M6.58541652,8.53333333 C5.63874972,8.53333333 4.87430541,7.76444499 4.87430541,6.82222222 C4.87430541,5.87999946 5.63875039,5.11111111 6.5854172,5.11111111 C7.52763928,5.11111111 8.29652831,5.87999946 8.29652831,6.82222222 C8.29652831,7.76888835 7.532084,8.53333333 6.5854172,8.53333333 L6.58541652,8.53333333 Z M19.1231939,19.3333333 L16.172083,19.3333333 L16.172083,14.7111111 C16.172083,13.6088894 16.1498608,12.1911112 14.6387497,12.1911112 C13.1009717,12.1911112 12.8654167,13.3911106 12.8654167,14.6311117 L12.8654167,19.3333333 L9.91430581,19.3333333 L9.91430581,9.83111098 L12.7454168,9.83111098 L12.7454168,11.1288886 L12.7854165,11.1288886 C13.1809718,10.3822218 14.1454161,9.59555528 15.5809725,9.59555528 C18.5676383,9.59555528 19.1231939,11.5644443 19.1231939,14.1244439 L19.1231939,19.3333333 Z"
            />
        </svg>
    );
};

export default React.memo(Linkedin);
